<template>
	<div>
		<b-card no-body>
			<template #header>
				<b-row>
					<b-col cols="1" class="p-2">
						<b-icon v-if="assignment.Flagged == true" icon="exclamation-circle-fill" variant="danger" font-scale="1.5" class="mr-3 ml-2"></b-icon>
						<b-icon v-else-if="assignment.SignedOff == true" icon="check-circle" variant="success" font-scale="1.5" class="mr-3 ml-2"></b-icon>
						<b-icon v-else-if="assignment.Users.length > 0" icon="circle-fill" font-scale="1.5" class="mr-3 ml-2"></b-icon>
						<b-icon v-else icon="circle" font-scale="1.5" class="mr-3 ml-2"> </b-icon>
					</b-col>

					<div class="col-9 ml-n3 mr-3" v-if="isEditing && assignment.TaskSubType == 1">
						<input v-model="assignment.Title" type="text" class="form-control" />
					</div>
					<div v-else class="col-9 ml-n3 mr-3 emu-input">
						<b-link v-b-toggle="`collapse-${type}-${index}`">{{ assignment.Title }}</b-link>
					</div>
					

					<div v-if="assignment.Open" class="col-2 emu-input">
						<span v-if="assignment.RouteId == null">
							<b-link class="float-right ml-3" title="Delete task" @click.prevent="deleteTask">
								<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
							</b-link>

							<save-or-edit-buttons :editable="isEditing" section="isEditing" @save="updateTask" @edit="editSection"></save-or-edit-buttons>
						</span>
						<span v-else>
							<b-link class="float-right ml-3" :href="`/routeplans/${assignment.RouteId}/update`">Go to route plan</b-link>
						</span>
					</div>

					<div v-else class="col-2 p-2 emu-input">
						<b-link class="float-right ml-3" title="Change order">
							<b-icon class="handle" font-scale="1.5" icon="list"></b-icon>
						</b-link>
					</div>
				</b-row>
			</template>

			<b-collapse :id="`collapse-${type}-${index}`">
				<b-card-body>
					<b-card-text v-if="assignment.TaskSubType == 1">
						<b-row v-if="isEditing" class="mb-3">
							<b-col cols="2">
								<b-form-group label="Hours" for="hours">
									<b-form-input v-model="assignment.Hours" type="number" min="0" step="0.5" />
								</b-form-group>
							</b-col>

							<b-col cols="4">
								<b-form-group label="Due" for="due">
									<b-form-datepicker v-model="assignment.Scheduled"></b-form-datepicker>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group label="Assigned to" for="assignees">
									<v-select multiple v-model="assignment.Users" label="FullName" :options="engineers"></v-select>
								</b-form-group>
							</b-col>

							<b-col cols="3" v-if="assignment.SignedOff == false">
								<b-form-checkbox v-model="assignment.Flagged" switch :value="true" :unchecked-value="false" size="lg">Flagged</b-form-checkbox>
							</b-col>
							<b-col v-if="assignment.SignedOff == true" cols="3">
								<b-form-checkbox v-model="assignment.SignedOff" switch :value="true" :unchecked-value="false" size="lg">Signed off</b-form-checkbox>
							</b-col>
						</b-row>

						<b-row class="mb-3" v-else>
							<b-col cols="2">
								Hours: {{ hoursTotal }} /
								{{ assignment.Hours }}
							</b-col>

							<b-col cols="4">
								Due:
								{{ formatDate(assignment.Scheduled) }}
							</b-col>
							<b-col cols="6">
								Assigned to:
								<span v-for="(user, index) in assignment.Users" :key="user.Id">
									{{ user.FullName }}
									<span v-if="index != assignment.Users.length - 1">,</span>
								</span>
							</b-col>
						</b-row>

						<b-tabs v-if="!isEditing" content-class="mt-3">
							<b-tab title="Time" active>
								<b-row class="mt-3">
									<b-col cols="10">
										<h4>Time log</h4>
									</b-col>

									<b-col cols="2">
										<b-link class="float-right mb-3" title="Add an allocation" @click.prevent="setAllocationDialog(assignment.Id)">
											<b-icon font-scale="1.5" icon="plus-square"></b-icon>
										</b-link>
									</b-col>
								</b-row>

								<b-table-simple bordered>
									<b-thead head-variant="light">
										<tr>
											<th>Engineer</th>
											<th>Date</th>
											<th>Hours</th>
											<th style="width: 12.5%"></th>
										</tr>
									</b-thead>

									<b-tbody>
										<tr v-for="(allocation, index) in assignment.AssignmentTimes" :key="index + 10">
											<td class="align-middle">
												{{ allocation.FirstName }}
												{{ allocation.LastName }}
											</td>

											<td v-if="allocation.Editable">
												<b-form-datepicker v-model="allocation.Added"></b-form-datepicker>
											</td>
											<td v-else>
												{{ formatDate(allocation.Added) }}
											</td>

											<td v-if="allocation.Editable" class="align-middle">
												<b-form-input v-model="allocation.Hours" type="number" min="0" step="0.5" />
											</td>
											<td v-else class="align-middle">
												<div class="emu-input">
													{{ allocation.Hours }}
												</div>
											</td>

											<td class="align-middle">
												<b-link class="ml-3 float-right" v-if="!allocation.Editable" title="Remove this Allocation" @click.prevent="removeFromArray('AssignmentTimes', index, true)">
													<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
												</b-link>

												<save-or-edit-buttons-row :section="allocation" @save="updateTask"></save-or-edit-buttons-row>
											</td>
										</tr>
									</b-tbody>
								</b-table-simple>
							</b-tab>

							<b-tab title="Materials">
								<b-row class="mt-3">
									<b-col cols="10">
										<h4>Materials used</h4>
									</b-col>

									<b-col cols="2">
										<b-link class="float-right mb-3" title="Add material used" @click.prevent="setMaterialDialog(assignment.Id)">
											<b-icon font-scale="1.5" icon="plus-square"></b-icon>
										</b-link>
									</b-col>
								</b-row>

								<b-table-simple bordered>
									<b-thead head-variant="light">
										<tr>
											<th>Type</th>
											<th>Material</th>

											<th style="width: 12.5%"></th>
										</tr>
									</b-thead>

									<b-tbody>
										<tr v-for="(material, index) in assignment.AssignmentMaterials" :key="material.Id">
											<td class="align-middle">
												{{ material.Type }}
											</td>

											<td v-if="material.Editable" class="align-middle">
												<v-select v-model="material.Name" selectOnTab pushTags taggable label="Name" :reduce="(subs) => subs.Name" :options="filteredSubMaterials" />
											</td>
											<td v-else class="align-middle">
												<div class="emu-input">
													{{ material.Name }}
												</div>
											</td>

											<td class="align-middle">
												<b-link class="ml-3 float-right" v-if="!material.Editable" title="Remove material" @click.prevent="removeFromArray('AssignmentMaterials', index, true)">
													<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
												</b-link>

												<save-or-edit-buttons-row :section="material" @save="updateTask" @edit="setSubMaterials(material.MaterialId)"></save-or-edit-buttons-row>
											</td>
										</tr>
									</b-tbody>
								</b-table-simple>
							</b-tab>

							<b-tab lazy title="Files">
								<document-assets :assets="assignment.Assets" type="0" :relate="assignmentId" folder="Assignment"></document-assets>

								<file-assets :assets="assignment.Assets" type="1" :relate="assignmentId" folder="Assignment"></file-assets>
							</b-tab>

							<b-tab title="Notes">
								<b-row class="mt-3">
									<b-col cols="10">
										<h4>Additional notes</h4>
									</b-col>

									<b-col cols="2">
										<b-link class="float-right mb-3" title="Add a note" @click.prevent="setNoteDialog(assignment.Id)">
											<b-icon font-scale="1.5" icon="plus-square"></b-icon>
										</b-link>
									</b-col>
								</b-row>

								<b-table-simple bordered>
									<b-thead head-variant="light">
										<tr>
											<th>Date</th>
											<th>Person</th>
											<th>Note</th>

											<th style="width: 12.5%"></th>
										</tr>
									</b-thead>

									<b-tbody>
										<tr v-for="(log, index) in logs" :key="index + 10">
											<td class="align-middle">
												{{ formatDate(log.Added) }}
											</td>

											<td class="align-middle">
												{{ log.FullName }}
											</td>

											<td v-if="log.Editable" class="align-middle">
												<b-form-input v-model="log.Note" type="text" />
											</td>
											<td v-else class="align-middle">
												<div class="emu-input">
													{{ log.Note }}
												</div>
											</td>

											<td class="align-middle">
												<b-link class="ml-3 float-right" v-if="!log.Editable" title="Remove note" @click.prevent="deleteNote(index, true)">
													<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
												</b-link>

												<save-or-edit-buttons-row :section="log" @save="updateNote(log)"></save-or-edit-buttons-row>
											</td>
										</tr>
									</b-tbody>
								</b-table-simple>
							</b-tab>
						</b-tabs>

						<b-row class="mb-3">
							<b-col v-if="canShowSignOffButton" cols="6">
								<b-button variant="success" title="Sign off on this task" @click.prevent="signOff">Sign off</b-button>
							</b-col>

							<b-col class="d-flex justify-content-end">
								<small class="mt-auto">Updated :{{ formatDate(assignment.Updated) }}</small>
							</b-col>
						</b-row>
					</b-card-text>

					<b-card-text v-else>
						<!-- check in and out,  can't edit if part of a routeplan -->

						<b-row v-if="isEditing" class="mb-3">
							<b-col cols="6">
								<b-form-group label="Date" for="date">
									<b-form-datepicker v-model="assignment.Scheduled"></b-form-datepicker>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group label="Assigned to" for="assignees">
									<v-select @input="setSingleUser" v-model="assignment.Users" label="FullName" :options="engineers"></v-select>
								</b-form-group>
							</b-col>

							<b-col v-if="assignment.SignedOff == true" cols="3">
								<b-form-checkbox v-model="assignment.SignedOff" switch :value="true" :unchecked-value="false" size="lg">Signed off</b-form-checkbox>
							</b-col>
						</b-row>

						<b-row v-else class="mb-3">
							<b-col cols="6">
								Date:
								{{ formatDate(assignment.Scheduled) }}
							</b-col>
							<b-col cols="6">
								Assigned to:
								<span v-for="(user, index) in assignment.Users" :key="user.Id">
									{{ user.FullName }}
									<span v-if="index != assignment.Users.length - 1">,</span>
								</span>
							</b-col>
						</b-row>

						<b-tabs v-if="!isEditing" content-class="mt-3">
							<b-tab title="Notes" active>
								<b-row class="mt-3">
									<b-col cols="10">
										<h4>Additional notes</h4>
									</b-col>

									<b-col cols="2">
										<b-link class="float-right mb-3" title="Add a note" @click.prevent="setNoteDialog(assignment.Id)">
											<b-icon font-scale="1.5" icon="plus-square"></b-icon>
										</b-link>
									</b-col>
								</b-row>

								<b-table-simple bordered>
									<b-thead head-variant="light">
										<tr>
											<th>Date</th>
											<th>Person</th>
											<th>Note</th>

											<th style="width: 12.5%"></th>
										</tr>
									</b-thead>

									<b-tbody>
										<tr v-for="(log, index) in logs" :key="index + 10">
											<td class="align-middle">
												{{ formatDate(log.Added) }}
											</td>

											<td class="align-middle">
												{{ log.FullName }}
											</td>

											<td v-if="log.Editable" class="align-middle">
												<b-form-input v-model="log.Note" type="text" />
											</td>
											<td v-else class="align-middle">
												<div class="emu-input">
													{{ log.Note }}
												</div>
											</td>

											<td class="align-middle">
												<b-link class="ml-3 float-right" v-if="!log.Editable" title="Remove note" @click.prevent="deleteNote(index, true)">
													<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
												</b-link>

												<save-or-edit-buttons-row :section="log" @save="updateNote(log)"></save-or-edit-buttons-row>
											</td>
										</tr>
									</b-tbody>
								</b-table-simple>
							</b-tab>
						</b-tabs>

						<b-row class="mb-3">
							<b-col v-if="canShowSignOffButton" cols="6">
								<b-button variant="success" title="Sign off on this task" @click.prevent="signOff">Sign off</b-button>
							</b-col>

							<b-col class="d-flex justify-content-end">
								<small class="mt-auto">Updated :{{ formatDate(assignment.Updated) }}</small>
							</b-col>
						</b-row>
					</b-card-text>
				</b-card-body>
			</b-collapse>
		</b-card>

		<div v-b-hover="handleHover" class="rounded border primary mt-1 mb-1 py-2 task-push" :id="`popover-${type}-${index}`">
			<div v-if="isHovered">
				<b-row v-if="type == 1">
					<b-col>
						<b-button size="sm" @click.prevent="addTask(1)" variant="light" class="float-right mr-3">+ Task</b-button>
					</b-col>
				</b-row>

				<b-row v-else>
					<b-col>
						<b-button size="sm" @click.prevent="addTask(1)" variant="light" class="float-right mr-3">+ Task</b-button>
						<b-button size="sm" @click.prevent="addTask(2)" class="float-right mr-3" variant="light">+ Check-out</b-button>
						<b-button size="sm" @click.prevent="addTask(0)" class="float-right mr-3" variant="light">+ Check-in</b-button>
					</b-col>
				</b-row>
			</div>
		</div>

		<b-popover :target="`popover-${type}-${index}`" triggers="hover" placement="right" variant="light">
			<b-icon font-scale="1.5" animation="cylon" icon="arrow-left"></b-icon>
		</b-popover>

		<b-modal ref="sharedModal" :title="modalTitle" hide-footer no-close-on-backdrop>
			<add-note v-if="modalContent == 'note'" @addNote="addNote" entityType="Assignment" :entityId="assignment.Id" />

			<add-allocation v-if="modalContent == 'time'" @addAllocation="addAllocation" />

			<add-material v-if="modalContent == 'material'" @add="addMaterial" />

			<add-contact v-if="modalContent == 'task-contact'" @addContact="setTaskContact" />
		</b-modal>

		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import AssignmentService from '@/api-services/assignment.service';
import ContactService from '@/api-services/contact.service';
import LogService from '@/api-services/log.service';

import AddNote from '@/components/partials/add-task-note';
import AddContact from '@/components/partials/add-contact-to-parent';
import FileAssets from '@/components/partials/file-assets';
import DocumentAssets from '@/components/partials/document-assets';
import AddAllocation from '@/components/partials/add-allocation';
import AddMaterial from '@/components/partials/add-material-to-task';
import SaveOrEditButtons from '@/components/partials/save-or-edit-buttons';
import SaveOrEditButtonsRow from '@/components/partials/save-or-edit-buttons-row';
import Confirm from '@/components/partials/confirm';

import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import { dateFuncs } from '@/globs.js';

var timer;

export default {
	name: 'JobTaskList',

	components: {
		SaveOrEditButtons,
		SaveOrEditButtonsRow,
		AddNote,
		AddContact,
		AddAllocation,
		FileAssets,
		DocumentAssets,
		AddMaterial,
		VSelect,
		Confirm
	},

	// things we have inherited from our parent
	props: ['assignmentId', 'index', 'type', 'engineers', 'subMaterials', 'creating'],

	data() {
		return {
			assignment: {
				Open: false,
				AssignmentMaterials: [],
				AssignmentTimes: [],
				Users: [],
				Assets: []
			},
			logs: [],

			selectedMaterial: null,

			isCreating: false,
			isEditing: false,
			isHovered: false,

			modalContent: null,
			modalTitle: 'Select'
		};
	},

	created() {
		if (this.creating) {
			// map the prop to our own data so we can change it,
			// if this is new it needs to open as editable
			this.isCreating = true;
			this.isEditing = true;
		}
		// load the assignment data by id
		this.fetchAssignment();
	},

	mounted() {
		let vm = this;

		// watch for the collapse state being triggered, and then set our own state for the template
		// we also trigger this manually on adding a new task
		vm.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
			if (isJustShown != null) {
				// as this is global, we need to match this particular assignmnet collapse id
				if (collapseId == 'collapse-' + vm.type + '-' + vm.index) {
					if (isJustShown) {
						this.assignment.Open = true;
					} else {
						this.assignment.Open = false;
					}
				}
			}
		});
	},

	computed: {
		hoursTotal() {
			return this.assignment.AssignmentTimes.reduce(function (acc, obj) {
				return acc + parseFloat(obj.Hours);
			}, 0);
		},

		canShowSignOffButton() {
			return (this.isEditing == false || this.isEditing == 'undefined') && this.assignment.Flagged == false && this.assignment.SignedOff == false;
		},

		filteredSubMaterials() {
			let vm = this;

			return this.subMaterials.filter(function (subMaterial) {
				return subMaterial.MaterialId === vm.selectedMaterial;
			});
		}
	},

	methods: {
		setSingleUser(ev) {
			this.assignment.Users = [];
			if (ev) {
				this.assignment.Users.push(ev);
			}
		},

		setTaskContact() {},

		handleHover(hovered) {
			let vm = this;

			if (hovered) {
				timer = setTimeout(function () {
					vm.isHovered = hovered;
				}, 500);
			} else {
				clearTimeout(timer);
				vm.isHovered = hovered;
			}
		},

		editSection(section) {
			this[section] = true;
		},

		removeFromArray(section, index, hold) {
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to remove this item from ' + section).then((confirm) => {
					if (confirm) {
						this.removeFromArray(section, index);
					}
				});
			} else {
				this.$delete(this.assignment[section], index);
				this.updateTask();
			}
		},

		fetchAssignment() {
			let vm = this;
			AssignmentService.get(vm.assignmentId)
				.then((res) => {
					vm.assignment = res.data;

					// open state is not part of the model, set it to false
					vm.$set(vm.assignment, 'Open', false);

					// if we got here from adding a new task, then we need to open the task for editing
					if (vm.isCreating) {
						vm.assignment.Open = true;
						vm.isCreating = false; // turn this off just in case, we aren't creating anymore.
					}

					vm.fetchLogs();
				})
				.catch((error) => {
					console.log(error.response.data);
				});
		},

		fetchLogs() {
			LogService.get('Assignment', this.assignment.Id)
				.then((response) => {
					this.logs = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		setSubMaterials(materialId) {
			this.selectedMaterial = materialId;
		},

		addTask(taskSubType) {
			this.$emit('add', this.type, this.index, taskSubType);
		},

		updateTask(section) {
			// double check if it part of a route

			if (this.assignment.RouteId == null) {
				AssignmentService.update(this.assignment.Id, this.assignment)
					.then(() => {
						if (section) this[section] = false;
					})
					.catch((error) => {
						this.handleError(error);
					});
			} else {
				this.handleError('This task is part of a route and cannot be edited here, please go to the route');
			}
		},

		deleteTask() {
			let vm = this;

			vm.$refs.confirm.open('Confirm action', 'Are you sure you want delete this task?').then((confirm) => {
				if (confirm) {
					// delete from API first
					AssignmentService.delete(vm.assignment.Id)
						.then((res) => {
							// tell parent to remove from relevant array
							vm.$emit('delete', vm.type, vm.index);
						})
						.catch((error) => {
							this.handleError(error);
						});
				}
			});
		},

		setNoteDialog(id) {
			this.modalContent = 'note';
			this.modalTitle = 'Add note';
			this.$refs.sharedModal.show();
		},

		addNote(newNote) {
			if (newNote.Flag) {
				this.assignment.Flagged = true;
				this.updateTask();
			}
			this.fetchLogs();
			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		deleteNote(index, hold) {
			let vm = this;
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to delete this note?').then((confirm) => {
					if (confirm) {
						vm.deleteNote(index);
					}
				});
			} else {
				let log = vm.logs[index];
				LogService.delete(log.Id)
					.then((res) => {
						vm.$delete(vm.logs, index);
					})
					.catch((error) => {
						this.handleError(error);
					});
			}
		},

		updateNote(log) {
			LogService.update(log.Id, log);
		},

		setAllocationDialog(id) {
			this.modalContent = 'time';
			this.modalTitle = 'Add allocation';
			this.$refs.sharedModal.show();
		},

		addAllocation(incomingUser) {
			let newAllocation = {
				ApplicationUserId: incomingUser.Id,
				FirstName: incomingUser.FirstName,
				LastName: incomingUser.LastName,
				Hours: 0,
				Added: dateFuncs.today()
			};

			this.assignment.AssignmentTimes.push(newAllocation);

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		setMaterialDialog(id) {
			this.modalContent = 'material';
			this.modalTitle = 'Add material';
			this.$refs.sharedModal.show();
		},

		addMaterial(incomingMaterial) {
			let newMaterial = {
				MaterialId: incomingMaterial.Id,
				Type: incomingMaterial.Name,
				Name: ''
			};

			this.assignment.AssignmentMaterials.push(newMaterial);

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		formatDate(date) {
			return dateFuncs.humanDateFormat(date);
		},

		signOff() {
			this.$refs.confirm.open('Confirm action', 'Are you sure you want to sign off this task?').then((confirm) => {
				if (confirm) {
					this.assignment.SignedOff = true;
					(this.assignment.Completed = dateFuncs.today()), (this.isEditing = false);
					//this.assignment.Open = false;
					this.updateTask();

					this.$nextTick(() => {
						this.$root.$emit('bv::toggle::collapse', 'collapse-' + this.type + '-' + this.index);
					});
				}
			});
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	},

	watch: {
		// did the parent index change? this data is not reactive outside the components
		assignmentId() {
			this.$nextTick(() => {
				this.fetchAssignment();
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/job/job-task.vue